import { Autocomplete, Box, Button, Grid, Stack, TextField, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Header from 'components/Header'
import { FaSave } from 'react-icons/fa'
import { getIncidentItems } from 'store/discipline/incident'
import { update as updateAttendanceSettings } from 'store/attendance/attendance-settings'
import { BasePathProvider, useBasePath } from 'components/Providers'

export default function AttendanceSettingsForm({ selected, onClose }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const basePath = useBasePath()

  const incidentItems = useSelector(state => state.discipline.disciplineIncident.incidentItems)

  useEffect(() => {
    incidentItems?.length || dispatch(getIncidentItems())
  }, [dispatch, incidentItems])

  const demeritItems =
    incidentItems?.filter(item => item.enabled !== false && item.meritType?.toLowerCase() === 'demerit') || []

  const findIncidentItem = incidentId => {
    if (!incidentId) return null
    return demeritItems.find(item => Number(item.id) === Number(incidentId)) || null
  }

  const [dailyIncident, setDailyIncident] = useState(
    findIncidentItem(selected?.dailyIncident?.[0]?.incidentItemId),
  )
  const [periodIncident, setPeriodIncident] = useState(
    findIncidentItem(selected?.periodIncident?.[0]?.incidentItemId),
  )

  useEffect(() => {
    setDailyIncident(findIncidentItem(selected?.dailyIncident?.[0]?.incidentItemId))
    setPeriodIncident(findIncidentItem(selected?.periodIncident?.[0]?.incidentItemId))
  }, [selected, incidentItems])

  const renderIncidentLabel = option => {
    if (!option) return ''
    return `${option.name} (${option.point})`
  }

  const handleSave = () => {
    const payload = {
      id: selected.id,
      dailyIncidentId: dailyIncident?.id ?? null,
      periodIncidentId: periodIncident?.id ?? null,
    }

    dispatch(updateAttendanceSettings(payload)).then(() => {
      onClose()
    })
  }

  return (
    <BasePathProvider value={basePath}>
      <Box sx={{ overflowY: 'auto' }}>
        <Header title={t('Edit Demerit Point')} small close={onClose} borderBottom />

        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid item xs={12}>
            <Typography sx={{ fontWeight: 500, mb: 1 }}>{t('Attendance Type')}</Typography>
            <TextField
              fullWidth
              size="small"
              label={t('Type')}
              value={selected?.name || ''}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ fontWeight: 500, mt: 2 }}>{t('Demerit Point')}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              fullWidth
              size="small"
              options={demeritItems}
              value={dailyIncident}
              onChange={(event, value) => setDailyIncident(value)}
              getOptionLabel={option => renderIncidentLabel(option)}
              isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
              renderInput={params => (
                <TextField {...params} label={t('Daily Demerit Point')} />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              fullWidth
              size="small"
              options={demeritItems}
              value={periodIncident}
              onChange={(event, value) => setPeriodIncident(value)}
              getOptionLabel={option => renderIncidentLabel(option)}
              isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
              renderInput={params => (
                <TextField {...params} label={t('Period Demerit Point')} />
              )}
            />
          </Grid>
        </Grid>

        <Stack justifyContent="flex-end" flexDirection="row" sx={{ mr: 2, mt: 2 }}>
          <Button size="small" variant="contained" startIcon={<FaSave />} onClick={handleSave}>
            {t('SAVE')}
          </Button>
        </Stack>
      </Box>
    </BasePathProvider>
  )
}